import { getResizedImageUrl } from '@raisin/cp-utils';
import {
  DescriptionDocumentID,
  DescriptionDocumentType,
  MediaType,
  PartnerBankElement,
} from '../../types';
import { formatBankAdditionalDetails } from '../bankPageUtils/bankAdditionalDetails';
import bankInfoMessages from 'components/Banks/BankDetails/BankAdditionalDetails/messages';

const CONTRACT_MODEL = {
  direct: true,
  trust: false,
};

export const mapBipsToObsPartnerBank = (bipsProduct, t, intl): PartnerBankElement => {
  const depositTakingBank = bipsProduct?.deposit_taking_bank;

  return {
    id: depositTakingBank.id,
    fiduciary: CONTRACT_MODEL[bipsProduct?.display?.contract_model],
    country: depositTakingBank?.branch_country?.unique_country_id,
    description: depositTakingBank?.description,
    bank_slug: depositTakingBank?.bank_slug,
    description_short: depositTakingBank?.description,
    name: depositTakingBank?.name,
    partner_bank_sharia_compliant: depositTakingBank?.shariah_compliant,
    cms_content: {
      logo: {
        id: DescriptionDocumentID.LogoURL,
        type: DescriptionDocumentType.Attachment,
        media_type: MediaType.ImagePNG,
        url_path: getResizedImageUrl({
          resizableUrl: depositTakingBank?.logo_url,
          fallbackUrl: depositTakingBank?.bank_logo_url,
          params: { width: 126 },
        }),
      },
    },
    withholding_tax_possible: depositTakingBank?.branch_country?.source_tax_applicable,
    tax_country: depositTakingBank?.branch_country?.id,
    rating: depositTakingBank?.branch_country?.rating,
    is_fiduciary: CONTRACT_MODEL[bipsProduct?.display?.contract_model],
    additional_details:
      depositTakingBank?.additional_details &&
      formatBankAdditionalDetails(depositTakingBank?.additional_details, intl, t, bankInfoMessages),
  };
};

export const mapBipsToObsProductOffersForPartnerBanks = (
  bipsProducts,
  intl,
  t,
): PartnerBankElement[] => {
  const partnerBanksMap = new Map<string, PartnerBankElement>();

  bipsProducts.entries.forEach((product) => {
    const bankId = product?.deposit_taking_bank?.id;

    if (!!bankId && !partnerBanksMap.has(bankId)) {
      partnerBanksMap.set(bankId, mapBipsToObsPartnerBank(product, t, intl));
    }
  });

  return Array.from(partnerBanksMap.values());
};
